export default __webpack_public_path__ + "static/media/deposit.2869bb26.svg";